var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddNewLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79169 0.5C8.10811 0.5 8.36961 0.735008 8.41103 1.04007L8.41678 1.12488L8.41778 7.16667H14.462C14.8072 7.16667 15.087 7.4465 15.087 7.79167C15.087 8.10808 14.8519 8.36958 14.5469 8.411L14.462 8.41667H8.41778L8.41953 14.4576C8.41953 14.8028 8.13978 15.0828 7.79461 15.0828C7.47819 15.0828 7.2167 14.8478 7.1752 14.5427L7.16953 14.4578L7.16778 8.41667H1.12695C0.781778 8.41667 0.501953 8.13683 0.501953 7.79167C0.501953 7.47525 0.737087 7.21375 1.04214 7.17233L1.12695 7.16667H7.16778L7.16678 1.12512C7.1667 0.77995 7.44644 0.5 7.79169 0.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewLeague);
export default __webpack_public_path__ + "static/media/add-new-league.b257c147130c150096ee30d743a12480.svg";
export { ForwardRef as ReactComponent };